import React, { useContext } from 'react';
import { useOutletContext } from 'react-router-dom';

import { SimpleAppBar } from '_lib/components/AppBar/SimpleAppBar';
import { FlexBox } from '_lib/components/FlexBox/FlexBox';

import { AppRouteContext } from '../App/app.types';
import { AuthContext } from '../auth/authContext';
import { CallCenterUpdate } from '../CallCenter/CallCenterUpdate';
import { RouteErrorBoundary } from '../Routing/RouteErrorBoundary';

export const MyCallCenterRoute = () => {
  const { appDrawerState } = useOutletContext<AppRouteContext>();

  const { authUserCacheResource } = useContext(AuthContext);

  const cachedAuthUserQuery = authUserCacheResource.useCacheQuery();

  return (
    <FlexBox sx={{ flexDirection: 'column', height: '100%', width: '100%' }}>
      <SimpleAppBar title='My Call Center' onAppDrawerToggleClicked={appDrawerState?.openSlidingDrawer} />
      {cachedAuthUserQuery.data?.callCenterId ? (
        <CallCenterUpdate
          authUser={cachedAuthUserQuery.data}
          callCenterId={cachedAuthUserQuery.data.callCenterId}
          isFetchingFromProps={cachedAuthUserQuery.isFetching}
        />
      ) : (
        <RouteErrorBoundary appBarTitle='My Call Center' errorTitle='Error Fetching My Call Center' />
      )}
    </FlexBox>
  );
};
